import { render, staticRenderFns } from "./SendGift.vue?vue&type=template&id=4507e825&scoped=true"
import script from "./SendGift.vue?vue&type=script&lang=js"
export * from "./SendGift.vue?vue&type=script&lang=js"
import style0 from "./SendGift.vue?vue&type=style&index=0&id=4507e825&prod&lang=scss&scoped=true"
import style1 from "./SendGift.vue?vue&type=style&index=1&id=4507e825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507e825",
  null
  
)

export default component.exports